import { render, staticRenderFns } from "./modal-action-product.vue?vue&type=template&id=85ef30b2&scoped=true"
import script from "./modal-action-product.vue?vue&type=script&lang=js"
export * from "./modal-action-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ef30b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85ef30b2')) {
      api.createRecord('85ef30b2', component.options)
    } else {
      api.reload('85ef30b2', component.options)
    }
    module.hot.accept("./modal-action-product.vue?vue&type=template&id=85ef30b2&scoped=true", function () {
      api.rerender('85ef30b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-target_product/modal-action-product.vue"
export default component.exports